define([
  'immutable',
  'es6!sumo/util',
  'es6!launcher/actions/automations/Actions',
], (Immutable, Util, Actions) => {
  const initialState = Immutable.Map({
    automation: Immutable.Map(),
    automations: Immutable.List(),
    subscriberLists: Immutable.List(), // Will exist in subscribers/list reducer
    total: 0,
  });

  const actionHandlers = {};

  actionHandlers[Actions.RECEIVE_AUTOMATION] = (state, action) => {
    const automation = Immutable.fromJS(action.automation);
    const id = automation.get('id');

    let automations = state.get('automations');
    automations.forEach((a, index) => {
      if (a.get('id') === id) {
        automations = automations.set(index, automation);
      }
    });

    return state.merge({
      automation,
      automations,
    });
  };

  actionHandlers[Actions.RECEIVE_AUTOMATIONS] = (state, action) => {
    const { data } = action;
    const { automations, total } = data;

    return state.merge(Immutable.fromJS({
      automations,
      total,
    }));
  };

  actionHandlers[Actions.UPDATE_AUTOMATION] = (state, action) => {
    const { id, partial } = action;
    let automations = state.get('automations');

    automations.forEach((automation, index) => {
      if (automation.get('id') === id) {
        automations = automations.set(
          index, automation.merge(
            Immutable.fromJS(partial),
          ),
        );
      }
    });

    let newState = state.set('automations', automations);

    const automation = state.get('automation', Immutable.Map());
    if (automation.get('id') === id) {
      newState = newState.set('automation', automation.merge(
        Immutable.fromJS(partial),
      ));
    }

    return newState;
  };

  actionHandlers[Actions.RECEIVE_AUTOMATIONS_SUBSCRIBERS_LIST] = (state, action) => (
    state.set('subscriberLists', Immutable.fromJS(action.lists))
  );

  return Util.createReducer(initialState, actionHandlers);
});
